import styled from "styled-components";

export const CollectionGroupModalStyle = styled.div`

`;
